import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Default high resolution image loading behavior of the photo viewer.')) + " " + _toDisplayString(_ctx.t('memories', 'The configuration here also applies to public link shares.')) + " " + _toDisplayString(_ctx.t('memories', 'Users may override this setting.')) + " ", 1),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_NcCheckboxRadioSwitch, {
      modelValue: _ctx.config['memories.viewer.high_res_cond_default'],
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config['memories.viewer.high_res_cond_default']) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.viewer.high_res_cond_default')))
      ],
      value: "zoom",
      name: "vhrc_radio",
      type: "radio"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Load high resolution image on zoom')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_NcCheckboxRadioSwitch, {
      modelValue: _ctx.config['memories.viewer.high_res_cond_default'],
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config['memories.viewer.high_res_cond_default']) = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('memories.viewer.high_res_cond_default')))
      ],
      value: "always",
      name: "vhrc_radio",
      type: "radio"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Always load high resolution image (not recommended if using HEIC/TIFF)')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_NcCheckboxRadioSwitch, {
      modelValue: _ctx.config['memories.viewer.high_res_cond_default'],
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config['memories.viewer.high_res_cond_default']) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => (_ctx.update('memories.viewer.high_res_cond_default')))
      ],
      value: "never",
      name: "vhrc_radio",
      type: "radio"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Never load high resolution image')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}